import { createAction } from 'redux-act';

import TimestampPayload from '@/store/actions/TimestampPayload';

import Employee from '../../../../models/interfaces/Employee';
import CompanyPayload from './CompanyPayload';

export interface ModifyEmployeePayload extends CompanyPayload {
  employee: Employee;
}
export const modifyEmployee = createAction<ModifyEmployeePayload>('MODIFY_EMPLOYEE');

export interface EmployeeModifiedPayload extends CompanyPayload, TimestampPayload {
  employee: Employee;
}
export const employeeModified = createAction<EmployeeModifiedPayload>('EMPLOYEE_MODIFIED');

export interface EmployeeModifyFailedPayload extends CompanyPayload, TimestampPayload {
  employee: Employee;
}
export const employeeModifyFailed = createAction<EmployeeModifyFailedPayload>('EMPLOYEE_MODIFY_FAILED');
